import React from "react";

function IconPricePerSqft() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
      <path d="M10.408 13.725v-.682c1.681-.14 2.632-.988 2.632-2.358 0-1.16-.677-1.874-2.057-2.17l-.575-.118V6.485c.564.08.967.483.983.972h1.499c-.022-1.24-.989-2.116-2.482-2.256v-.73h-.752v.73c-1.6.13-2.546.978-2.546 2.299 0 1.123.693 1.864 1.982 2.165l.564.134v1.998c-.671-.07-1.128-.467-1.165-1H6.955c.005 1.311 1.02 2.16 2.701 2.257v.671h.752zm1.107-2.857c0 .542-.409.891-1.107.934V9.933c.752.14 1.107.44 1.107.935zM8.668 7.35c0-.478.408-.838.988-.87V8.24c-.65-.129-.988-.44-.988-.891z" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.75 4a.75.75 0 01.75.75v11.5a.75.75 0 01-1.5 0V4.75A.75.75 0 013.75 4z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 16.25a.75.75 0 01.75-.75h11.5a.75.75 0 010 1.5H3.75a.75.75 0 01-.75-.75z"
      />
    </svg>
  );
}

export default IconPricePerSqft;
